

const colors = {
    primario: "#1775C2",
    secundario: "#08477aff",
    negro: "#000000",
    blanco: "#FFFFFF",
    amariyo: "#ffb92cff",
    naranja: "#F9931F",
    rojo : "#D50808"
};


export default colors;